import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { ComponentBase } from '../../intefaces/interfaces';
import { Link } from '../../components/link/link';
import { SharedContent } from '../../services/shared-content/shared-content';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-hero-two-column-aligned',
  imports: [Link, NgOptimizedImage],
  templateUrl: './hero-two-column-aligned.html',
  styleUrl: './hero-two-column-aligned.css',
  encapsulation: ViewEncapsulation.None
})
export class HeroTwoColumnAligned {
  @Input() pageTitle!: string
  @Input() content!: ComponentBase

  private sharedContent = inject(SharedContent)
	pageName = this.sharedContent.pageName

}
